import { z } from "zod";
import { defineStepConfig, conditionalSocket } from "@erp/workflows";
import { entityOfType } from "../../../utils/system-entities";
import { SystemEntity } from "@erp/shared-types";

/**
 * Create AP Invoice Draft Step
 *
 * Creates an AP invoice record (status: DRAFT) with line items from extracted data.
 * Includes idempotency checks to avoid creating duplicates.
 *
 * Note: This is a backend-only step that requires database access.
 * The handler is registered in backend/src/workflows/steps/handlers/
 */
export const createAPInvoiceDraftStep = defineStepConfig({
  type: "create_ap_invoice_draft",
  name: "Create AP Invoice Draft",
  description: "Create AP invoice draft record with line items",
  category: "Data Access",
  libraryModule: "AccountsPayable",
  inputSchema: z.object({
    extractionResultId: z.uuid(),
  }),

  outputSchema: z.object({
    // Conditional so the step can short-circuit (return SOCKET_NOT_TAKEN) when
    // the extraction produced no usable invoice content — see handler for
    // details. Downstream steps wired to this socket are skipped in that case.
    apInvoice: conditionalSocket(entityOfType(SystemEntity.AP_INVOICE)),
    invoiceNumber: z.string().optional(),
    referenceIds: z
      .array(z.string())
      .optional()
      .describe("Array of PO numbers or other references from the invoice"),
  }),

  configSchema: z.object({
    // Future: add config for matching thresholds, auto-approval rules
  }),

  emits: [] as const,
});
